(function () {
  const Core = window.RB.Core;
  const Scripts = window.RB.Scripts;

  const STACKABLE_KW = { assault: 1, shield: 1, deflect: 1, hunt: 1 };

  Object.assign(Core, {
    tags(state, iid) {
      const c = Core.card(state, iid);
      const out = ((c && c.tags) || []).slice();
      const o = state.objs[iid];
      if (o) {
        for (const g of o.grants || []) if (g.k === "tag") out.push(g.value);
      }
      if (o && o.zone === "board") {
        for (const aIid of o.attachments || []) {
          const asc = Scripts.forCard(state, aIid);
          for (const t of (asc && asc.attachedTags) || []) out.push(t);
        }
      }
      return out;
    },

    hasTag(state, iid, tag) {
      return Core.tags(state, iid).some(function (t) { return t.toLowerCase() === String(tag).toLowerCase(); });
    },

    readyBlocked(state, iid) {
      const o = state.objs[iid];
      if (!o || o.zone !== "board") return false;
      if (!Core.isType(state, iid, "unit") && !Core.isType(state, iid, "gear")) return false;
      const own = Scripts.forCard(state, iid);
      if (own && own.noReady) return true;
      return Core.ruleSources(state, "auraNoEnemyReady").some(function (s) {
        return s.obj.controller !== o.controller && Core.auraScopeActive(s.obj, s.script);
      });
    },

    untargetableBy(state, iid, chooser) {
      const o = state.objs[iid];
      if (!o || chooser === undefined || o.controller === chooser) return false;
      if ((o.grants || []).some(function (g) { return g.k === "untargetable"; })) return true;
      const own = Scripts.forCard(state, iid);
      if (own && own.selfUntargetable) {
        const cond = own.selfUntargetableCond;
        if (!cond) return true;
        if (cond.k === "notInCombat" && !o.designation) return true;
        if (cond.k !== "notInCombat" && Scripts.staticCond(state, iid, o.controller, cond)) return true;
      }
      for (const s of Core.ruleSources(state, "auraUntargetable", { controller: o.controller })) {
        if (s.iid === iid) continue;
        if (s.rule.scope === "here" && !(s.obj.loc && o.loc && Core.sameLoc(s.obj.loc, o.loc))) continue;
        if (s.rule.lessMightThanSource && !(Core.effMight(state, iid) < Core.effMight(state, s.iid))) continue;
        return true;
      }
      return false;
    },

    keywords(state, iid) {
      const c = Core.card(state, iid);
      const o = state.objs[iid];
      const out = {};
      const addKw = function (n, v) {
        const name = n.toLowerCase();
        if (out[name] === undefined) out[name] = v === null || v === undefined ? true : v;
        else if (STACKABLE_KW[name]) out[name] += v === null || v === undefined ? 1 : v;
      };
      if (c && c.keywords) {
        let suppress = null;
        if (o && o.zone === "board") {
          const sc = Scripts.forCard(state, iid);
          if (sc && sc.suppressKw) suppress = sc.suppressKw;
        }
        for (const k of c.keywords) {
          const nm = k.name.toLowerCase();
          if (suppress && suppress.indexOf(nm) >= 0) continue;
          addKw(nm, k.value !== null && k.value !== undefined ? k.value : STACKABLE_KW[nm] ? 1 : null);
        }
      }
      if (o) {
        for (const g of o.grants) {
          if (g.k === "keyword") addKw(g.name, g.value);
        }
        if (o.zone === "board" || o.zone === "chain") {
          for (const kw of Scripts.staticKeywords(state, iid)) addKw(kw[0], kw[1]);
        }
      }
      return out;
    },

    dealsCombatDamage(state, iid) {
      const o = state.objs[iid];
      if (!o || o.zone !== "board") return false;
      const own = Scripts.forCard(state, iid);
      if (own && own.noCombatDamage) {
        const c = own.noCombatDamage;
        if (c === true || Scripts.staticCond(state, iid, o.controller, c)) return false;
      }
      for (const s of Core.ruleSources(state, "auraNoCombatDamage")) {
        if (s.iid === iid) continue;
        for (const r of s.rule) {
          if (!Scripts.auraMatch(state, r, s.iid, s.obj, iid, o, { whoDefault: "all" })) continue;
          if (r.lessMightThanSource && !(Core.effMight(state, iid) < Core.effMight(state, s.iid))) continue;
          return false;
        }
      }
      return true;
    },

    ignoresTankAt(state, p, bfIid) {
      return Scripts.anySource(state, "ignoreTankHere", { controller: p, atBf: bfIid });
    },

    hasKw(state, iid, kw) {
      return !!Core.keywords(state, iid)[kw];
    },

    kwVal(state, iid, kw) {
      const v = Core.keywords(state, iid)[kw];
      if (v === true) return 1;
      return v || 0;
    },

    baseMight(state, iid) {
      const c = Core.card(state, iid);
      const o = state.objs[iid];
      if (!c || c.might === null || c.might === undefined) return null;
      let setTo = null;
      for (const g of o.grants) {
        if (g.k === "setMight") setTo = g.value;
      }
      return setTo !== null ? setTo : c.might;
    },

    might(state, iid) {
      const o = state.objs[iid];
      let m = Core.baseMight(state, iid);
      if (m === null) return null;
      m += o.buffs * Core.buffValue(state, o);
      for (const g of o.grants) {
        if (g.k === "might") m += g.value;
      }
      for (const aIid of o.attachments) {
        const ac = Core.card(state, aIid);
        if (ac && typeof ac.might_bonus === "number") m += ac.might_bonus;
      }
      const kws = Core.keywords(state, iid);
      if (o.designation === "attacker") {
        if (kws.assault) m += kws.assault === true ? 1 : kws.assault;
      }
      if (o.designation === "defender" && kws.shield) m += kws.shield === true ? 1 : kws.shield;
      m += Scripts.staticMight(state, iid);
      return m;
    },

    effMight(state, iid) {
      const m = Core.might(state, iid);
      return m === null ? null : Math.max(0, m);
    },

    buffValue(state, o) {
      let v = 1;
      for (const g of o.grants) {
        if (g.k === "buffBonus") v += g.value;
      }
      return v;
    },

    lethalLeft(state, iid) {
      return Math.max(1, Core.effMight(state, iid) - Core.totalDamage(state.objs[iid]));
    },

    lethal(state, iid) {
      const o = state.objs[iid];
      const m = Core.effMight(state, iid);
      if (m === null) return false;
      const dmg = Core.totalDamage(o);
      if (dmg > 0 && Core.anyDamageLethal(state, o)) return true;
      const threshold = Math.max(1, m);
      return dmg >= threshold && dmg > 0;
    },

    anyDamageLethal(state, o) {
      if (o.zone !== "board") return false;
      const dealers = {};
      for (const d of o.damage || []) if (d && d.by !== undefined && d.by !== null) dealers[d.by] = true;
      if (!Object.keys(dealers).length) return false;
      return Core.ruleSources(state, "lethalAnyDamage").some(function (s) {
        const so = s.obj;
        for (const r of s.rule) {
          if (!dealers[so.controller]) continue;
          if (r.who === "enemy" && so.controller === o.controller) continue;
          if (r.who === "friendly" && so.controller !== o.controller) continue;
          if (r.cond && !Scripts.staticCond(state, s.iid, so.controller, r.cond)) continue;
          return true;
        }
        return false;
      });
    },

    combatTotal(state, bfIid, p) {
      let total = 0;
      const units = Core.unitsAt(state, { t: "bf", iid: bfIid }, function (o) { return o.controller === p; });
      for (const iid of units) {
        const o = state.objs[iid];
        total += o.stunned || !Core.dealsCombatDamage(state, iid) ? 0 : Core.effMight(state, iid);
      }
      return total;
    },

    victoryScore(state) {
      let v = state.mode.victory;
      for (const bfIid of state.battlefields || []) {
        const sc = Scripts.forCard(state, bfIid);
        if (sc && sc.victoryDelta) v += sc.victoryDelta;
      }
      return v;
    },
  });
})();
